import logoWhiteLong from "../assets/brand/logos/BlancoLargo.png";
import { TrackedImage } from "./ui/TrackedImage";

export function SiteFooter() {
  return (
    <footer className="bg-brand-secondary px-6 py-10 text-white sm:px-10 sm:py-14 lg:px-12 lg:py-16">
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-8 sm:items-center sm:justify-between lg:flex-row">
        <TrackedImage
          src={logoWhiteLong}
          alt="Organización Sionista del Uruguay"
          className="h-auto w-full max-w-[420px]"
        />
        <div className="text-right text-lg font-extrabold leading-tight sm:text-xl lg:text-2xl">
          <p>info@osu.org.uy</p>
          <p>099 492 137</p>
        </div>
      </div>
    </footer>
  );
}
